import { Progress } from "antd";
import LoaderDots from "component/loader/loader_dot";
import {
  FLOWS,
  useLoadingFinishFlow,
} from "hook/bailiff/document/flow/useLoadingFinishFlow";
import { useSelector } from "react-redux";
import { bailiffDocumentPercentProcessSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FinishLoading = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useLoadingFinishFlow();
  const isFlow = flow === FLOWS.LOADING;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const percent = useSelector(bailiffDocumentPercentProcessSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const startLoad = () => {
    if (percent <= 0.1) {
      return <LoaderDots />;
    }
  };

  const moreLoad = () => {
    if (percent > 0.1) {
      return (
        <Progress
          className="min-w-[300px]"
          size={{ height: 5 }}
          percent={percent}
          showInfo={false}
        />
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center">
      <div className="text-3xl font-bold">{percent}%</div>
      <div className="text-gray-400">Vui lòng chờ hệ thống xử lý</div>
      {startLoad()}
      {moreLoad()}
    </div>
  );
};
export default FinishLoading;
